@if (!hideSearch || canAdd) {
  <div class="list-view-toolbar">
    @if (state.numberOfEntries && !hideNumberOfEntries) {
      <div class="text-secondary text-xs">
        @if (!customDescription) {
          Showing
          {{ state.numberOfEntries || 0 }} {{ state.numberOfEntries === 1 ? 'entry' : 'entries' }}
        } @else {
          <span>{{ state.numberOfEntries || 0 }} {{ customDescription }}</span>

          @if (state.numberOfEntries !== 1) {
            <span>s</span>
          }
        }
      </div>
    }

    @if (state.displayResolver) {
      <ng-content select="[additionalToolbarActions]" />
    }
    <div class="search-wrapper">
      <div class="additional-buttons">
        <ng-content select="[listViewAdditionalButtons]" />
      </div>
      @if (state.displayResolver && !hideSearch) {
        <dojo-list-view-search-field
          [searchCtrl]="searchCtrl"
          [searchLabel]="searchLabel"
          [searchPlaceholder]="searchPlaceholder"
          [searchFieldClasses]="searchFieldClasses"
          [sizeSearchFiled]="sizeSearchFiled"
          class="list-view-search"
        />
        <ng-content select="[listViewSearchFields]" />
      }

      @if (canAdd && showToolbarAddButton && state.displayResolver) {
        <div matTooltip class="medium:self-end">
          <dojo-button
            [size]="sizeSearchFiled"
            [customColor]="'primary'"
            data-test="button-create-entity"
            (click)="addItem()"
            [disabled]="state.isLoading"
          >
            @if (showAddButtonIcon) {
              <dojo-icon class="mr-2" [icon]="'plus'" />
            }
            <span>{{ addButtonText }}</span>
          </dojo-button>
        </div>
      }
    </div>
  </div>
}

<div class="grow">
  <dojo-list-view-grid
    [messages]="messages"
    [searchCtrl]="searchCtrl"
    [gridOptions]="gridOptions"
    [columnDefs]="columnDefs"
    [components]="frameworkComponents"
    [hideLoader]="hideLoader"
    [incrementalLoading]="incrementalLoading"
    [canAdd]="canAdd"
    [agGridClass]="agGridClass"
    [agGridAdditionalClass]="agGridAdditionalClass"
    (add)="addItem()"
    (gridReady)="onGridReady($event)"
    (gridDestroy)="onGridDestroy()"
    (gridRowClicked)="rowClicked($event)"
    (gridRowDoubleClicked)="rowDoubleClicked($event)"
    (gridSelectionChanged)="gridSelectionChanged.emit($event)"
    (cellClicked)="cellClicked.emit($event)"
  />
</div>
